import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import React, { useRef, useContext, useEffect, useMemo, useState } from 'react';
import { Button, Col } from 'reactstrap';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useAuth0 } from '../../../../auth0/reactAuth0Spa';
import {
  urlWithHttpProtocol,
  formatBearerToken,
  openUrlInNewTabOrDetectBlock,
  preOpenNamedMeetingWindow,
  isArrayEqual,
  usePrevious,
  renderMeetingDetailsCard,
  getArrayIndexesWithDifferencesViaTimeSlot,
  checkLoginForError,
} from '../../../../Common.functions';
import { DepartmentContext } from '../../../../DepartmentWrapper';
import { clone } from '../../../../Services/schedule';
import {
  findInterviewDateInCollection,
  getInterviewDatePk,
  isPrescreenInterviewDate,
  normalizeInterviewDate,
  normalizeInterviewDatePk,
  PRESCREEN_INTERVIEW_DATE,
} from '../../../../Services/interviewDate';
import { fetchDataAgnostic, putData } from '../../../../Services/dataApi';
import {
  buildEvaluatorMeetingParams,
  createMeetingContext,
  getMeetingOperationKey,
} from '../../../../Services/meetingContext';
import { resolveMeetingWithRetry } from '../../../../Services/meetingJoinResolver';
import Loading from 'Body/Statuses/Loading';
import { EvaluatorPortalStateContext } from '../../EvaluatorPortalStateContext';
import { isEvaluatorHeaderMobile } from '../evaluatorHeaderLayout';

// Initialize Day.js plugins
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const candidateSortTypes = {
  Alphabetical: 'Alphabetical',
  EvalStatus: 'EvalStatus',
  University: 'University',
};
const REZRATE_VIDEO_WINDOW_TARGET = 'rezrate-video';

// handles mobile vs browser components.  Will reevaluate on resize

const filterCandidateInfo = (candidates) => {
  return candidates.filter((item) => {
    return item.Candidates4DateEvaluationStatus === 'In progress' || item.Candidates4DateEvaluationStatus === '';
  });
};

const MobileFork = (props) => {
  const {
    // adjacentDates,
    BrowserComponent,
    handleDateChange,
    hasNoUsers,
    headerHeight,
    isAdmin,
    isEmbedded,
    isPopout,
    match = { params: {} },
    MobileComponent,
    reduxDate: reduxDateProp,
    reduxDateArray: reduxDateArrayProp,
    selectedEvaluator,
    setReduxDate: setReduxDateProp,
    setReduxDateArray: setReduxDateArrayProp,
    setLargePhoto,
    setSeasonType,
    setShowLargePhoto,
    setUser,
    setZoomBreakRoom,
  } = props;
  const { pk_User } = selectedEvaluator || {};
  const dContext = useContext(DepartmentContext);
  const evaluatorPortalState = useContext(EvaluatorPortalStateContext);
  const { pk_InterviewDate } = match.params;
  const shouldUseLocalEvaluatorPortalState = !isAdmin && !isEmbedded && !!evaluatorPortalState;
  const allowPrescreen = !!(dContext && dContext.season && dContext.season.AllowPrescreen);
  const selectedReduxDate =
    shouldUseLocalEvaluatorPortalState && evaluatorPortalState ? evaluatorPortalState.date : reduxDateProp;
  const reduxDate = isPrescreenInterviewDate(selectedReduxDate) && !allowPrescreen ? null : selectedReduxDate;
  const reduxDateArray =
    shouldUseLocalEvaluatorPortalState && evaluatorPortalState ? evaluatorPortalState.dateArray : reduxDateArrayProp;
  const setReduxDate =
    shouldUseLocalEvaluatorPortalState && evaluatorPortalState ? evaluatorPortalState.setDate : setReduxDateProp;
  const setReduxDateArray =
    shouldUseLocalEvaluatorPortalState && evaluatorPortalState
      ? evaluatorPortalState.setDateArray
      : setReduxDateArrayProp;

  const [adjacentDates, setAdjacentDates] = useState([]);
  const [beginningTimeMinus30Minutes, setBeginningTimeMinus30Minutes] = useState(null);
  const [candidateInfo, setCandidateInfo] = useState(null);
  const [candidateLoadError, setCandidateLoadError] = useState(false);
  const [candidatesLoading, setCandidatesLoading] = useState(false);
  const oldGetInfoPayload = useRef({});
  const candidateRequestRef = useRef(0);
  const candidateSelectionRef = useRef({ id: null, version: 0, details: 0, status: 0, appliedStatusVersion: 0, evaluation: 0 });
  const renderedSelectionVersion = candidateSelectionRef.current.version;
  const [copied, setCopied] = useState(false);
  const [currentCandidateSortType, setCurrentCandidateSortType] = useState(candidateSortTypes.Alphabetical);
  const [endingTimePlus30Minutes, setEndingTimePlus30Minutes] = useState(null);
  const [heightOfHeader, setHeightOfHeader] = useState(201);
  const [incompleteCandidates, setIncompleteCandidates] = useState([]);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [isMobile, setIsMobile] = useState(isEvaluatorHeaderMobile(window.innerWidth));

  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const [sortCandAscending, setSortCandAscending] = useState(false);
  const [userInformation, setUserInformation] = useState(null);

  const [allDayRoom, setAllDayRoom] = useState(null);
  const [mainRoomUrlDetails, setMainRoomUrlDetails] = useState('');
  const [candidateEvaluationStatus, setCandidateEvaluationStatus] = useState('');
  const [differences, setDifferences] = useState([]);
  const [disableJoinMeetingButton, setDisableJoinMeetingButton] = useState(false);
  const [DNRStatus, setDNRStatus] = useState(null);
  const [evaluationsLocked, setEvaluationsLocked] = useState(false);
  const [firstBlockEarlyJoin, setFirstBlockEarlyJoin] = useState(0);
  const [firstBlockEarlyJoinInMinutes, setFirstBlockEarlyJoinInMinutes] = useState(0);
  const [interviewIsToday, setInterviewIsToday] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isQuietLoading, setIsQuietLoading] = useState(false);

  const [mainRoomDescription, setMainRoomDescription] = useState(null);
  const [meetingId, setMeetingId] = useState(null);
  const [schedule, setSchedule] = useState(null);
  const [Schedules4EvalJoinManualURL, setSchedules4EvalJoinManualURL] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [userIdOnCurrentInterview, setUserIdOnCurrentInterview] = useState(null);
  const [virtualMeetingMode, setVirtualMeetingMode] = useState('');
  const [enableEmbeddedMeetings, setEnableEmbeddedMeetings] = useState(false);
  const [zoomPassword, setZoomPassword] = useState('');

  const [activeTab, setActiveTab] = useState('1');
  const [alarms, setAlarms] = useState(null);
  const [candidateEvaluation, setCandidateEvaluation] = useState(null);
  const [currentlyGettingEval, setCurrentlGettingEval] = useState(false);
  const [dataTypes, setDataTypes] = useState([]);
  const [demo, setDemo] = useState(false);
  const [error, setError] = useState(false);
  const [evalStatus, setEvalStatus] = useState(null);
  const [expiredToken, setExpiredToken] = useState(false);
  const [highlightIsFading, setHighlightIsFading] = useState(false); // Used to countdown for highlight.
  const [indexesWithDifferences, setIndexesWithDifferences] = useState([]);
  const [interviewHasPassed, setInterviewHasPassed] = useState(true);
  const [lockedStatuses, setLockedStatuses] = useState(null);
  const [previousDate, setPreviousDate] = useState(null);
  const [Schedules4Eval__pkUUID_Schedule, setSchedules4Eval__pkUUID_Schedule] = useState(null);
  const [selectedCandidateId, setSelectedCandidateId] = useState(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
  const [showRed, setShowRed] = useState(false);
  const [showMeetingCard, setShowMeetingCard] = useState(false);
  const [minutes, setMinutes] = useState(5 * 60 * 1000);
  const [zoomInfo, setZoomInfo] = useState([]);
  const [nonZoomInfo, setNonZoomInfo] = useState('');

  const [meetingLink, setMeetingLink] = useState(null);
  const [isFetchingReduxDateArray, setIsFetchingReduxDateArray] = useState(false);
  const [isDateListLoaded, setIsDateListLoaded] = useState(reduxDateArray?.length > 0);
  const [minutesToUpdateToDisplay, setMinutesToUpdateToDisplay] = useState(minutes || 5000);

  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isGettingLoggedInUser, setIsGettingLoggedInUser] = useState(false);

  const minutesToUpdateToDisplayRef = useRef(minutesToUpdateToDisplay || 5000);
  const activeTabRef = useRef(); // Used for getting updated activeTab inside setter.
  const reduxDateRef = useRef(); // Used for getting updated reduxDate inside setter.
  const highlightIsFadingRef = useRef();
  const loadingRef = useRef({ isQuietLoading: false, isLoading: false }); // used for getting updated loading state inside setter.We mustn't getInfo when we're still getting info.
  const isPrescreenRef = useRef(isPrescreenInterviewDate(reduxDate)); // used for getting updated loading state inside setInterval getInfo updaters.We mustn't getInfo when we're still getting info.
  const pk_UserRef = useRef(); // To stop previously clicked user from overwriting last clicked user data.
  const pk_TimeSlotRef = useRef(); // To stop previously clicked candidate from overwriting last clicked candidate data.
  const previousDateIsDifferentRef = useRef(true);
  const hasFiredInactivityPopupRef = useRef(false);
  const updateIntervalRef = useRef(null);
  const inactivityIntervalRef = useRef(null);
  const countdownIntervalRef = useRef(null);
  const headerMeasureTimeoutRef = useRef(null);
  const activeEvaluatorMeetingKeyRef = useRef(null);
  const evaluatorMeetingOperationsRef = useRef(new Map());
  const prevAmount = usePrevious({ reduxDate });
  const adjacentDatesRef = useRef();

  const scheduleStartTime = useRef();
  const scheduleEndTime = useRef();

  // Alert functionality replaced with toast

  const { getTokenSilently, user, logout, loginWithRedirect } = useAuth0();
  const isPrescreen = isPrescreenInterviewDate(reduxDate);
  const activeReduxDate = useMemo(() => normalizeInterviewDate(reduxDate, reduxDateArray), [reduxDate, reduxDateArray]);
  const activeReduxDatePk = getInterviewDatePk(activeReduxDate);
  const activeReduxDateSignature = [
    activeReduxDatePk || '',
    activeReduxDate && activeReduxDate.DateOfInterview ? activeReduxDate.DateOfInterview : '',
    activeReduxDate && activeReduxDate.StartTime ? activeReduxDate.StartTime : '',
    isPrescreenInterviewDate(activeReduxDate) ? 'prescreen' : 'standard',
  ].join('|');
  const candidateContextKey = JSON.stringify([
    dContext && dContext.department && dContext.department.pk_Department,
    dContext && dContext.season && dContext.season.pk_Season,
    pk_User,
    isAdmin,
    activeReduxDateSignature,
    pk_InterviewDate,
    allowPrescreen,
  ]);
  const candidateContextRef = useRef(candidateContextKey);
  candidateContextRef.current = candidateContextKey;

  useEffect(
    () => () => {
      candidateRequestRef.current += 1;
      candidateContextRef.current = null;
    },
    [],
  );

  const inactivityWait = 15; // minutes

  useEffect(() => {
    if (error) {
      // Swal.fire(
      //   'Error',
      //   'Something went wrong when retrieving schedule data, please try again later or contact an administrator',
      //   'error',
      // );
    }
  }, [error]);

  useEffect(() => {
    loadingRef.current = { isQuietLoading, isLoading: isLoading || candidatesLoading };
  }, [isQuietLoading, isLoading, candidatesLoading]);

  useEffect(() => {
    isPrescreenRef.current = isPrescreen;
  }, [isPrescreen]);

  // this component is used in two different places. One of the places relies on path paremeters to change the date
  // and the other relies on a changing redux state of a interview date object. To make these work in tandam without
  // having to fork logic too much, use the path params to set the selected date object
  useEffect(() => {
    if (isEmbedded || !pk_InterviewDate) {
      if (!isEmbedded) {
        console.log('[EvaluatorPortal Debug] MobileFork route sync skipped', {
          pk_InterviewDate,
          reduxDateArrayLength: reduxDateArray ? reduxDateArray.length : 0,
          isEmbedded,
          activeReduxDatePk,
        });
      }
      return;
    }

    // A direct or stale Prescreen URL must not enable it for a season that disallows it.
    // Wait for season settings as well; this effect reruns when AllowPrescreen loads.
    if (isPrescreenInterviewDate(pk_InterviewDate) && !allowPrescreen) {
      return;
    }

    // console.log('pk_InterviewDate changed! ', pk_InterviewDate);
    // console.log('reduxDateArray: ', reduxDateArray);
    // console.log('interviewDates: ', interviewDates);
    // console.log('interviewDates: ', interviewDates);
    // console.log('reduxDate: ', reduxDate);
    if (normalizeInterviewDatePk(pk_InterviewDate) === normalizeInterviewDatePk(activeReduxDatePk)) {
      console.log('[EvaluatorPortal Debug] MobileFork route sync already aligned', {
        pk_InterviewDate,
        activeReduxDatePk,
      });
      return;
    }

    if (isPrescreenInterviewDate(pk_InterviewDate) && !isPrescreenInterviewDate(activeReduxDate)) {
      console.log('[EvaluatorPortal Debug] MobileFork route sync forcing Prescreen from route', {
        pk_InterviewDate,
        activeReduxDatePk,
      });
      setReduxDate(PRESCREEN_INTERVIEW_DATE);
      return;
    }

    // Prescreen is a virtual date and must initialize even before any interview dates exist.
    // Only real interview routes depend on the fetched date collection.
    if (!reduxDateArray || reduxDateArray.length === 0) {
      if (isDateListLoaded && allowPrescreen && !isPrescreenInterviewDate(activeReduxDate)) {
        setReduxDate(PRESCREEN_INTERVIEW_DATE);
      }
      return;
    }

    const dateFromPathParams = findInterviewDateInCollection(pk_InterviewDate, reduxDateArray);
    if (dateFromPathParams) {
      console.log('[EvaluatorPortal Debug] MobileFork route sync resolved route date', {
        pk_InterviewDate,
        resolvedPk: getInterviewDatePk(dateFromPathParams),
      });
      setReduxDate({ ...dateFromPathParams, allDayRoom: allDayRoom });
    } else {
      console.log('[EvaluatorPortal Debug] MobileFork route sync falling back to first date', {
        pk_InterviewDate,
        activeReduxDatePk,
        availableDatePks: (reduxDateArray || []).map((item) => getInterviewDatePk(item)),
        fallbackPk: reduxDateArray[0] ? getInterviewDatePk(reduxDateArray[0]) : null,
      });
      setReduxDate(normalizeInterviewDate(reduxDateArray[0], reduxDateArray));
    }
  }, [
    isEmbedded,
    pk_InterviewDate,
    reduxDateArray,
    activeReduxDate,
    activeReduxDatePk,
    allDayRoom,
    setReduxDate,
    allowPrescreen,
    isDateListLoaded,
  ]);

  useEffect(() => {
    candidateRequestRef.current += 1;
    candidateSelectionRef.current.version += 1;
    candidateSelectionRef.current.id = null;
    setSelectedCandidateId(null);
    setCandidateEvaluation(null);
    setCandidateEvaluationStatus('');
    setDNRStatus(null);
    setSelectedTimeSlot(null);
    pk_TimeSlotRef.current = null;
    oldGetInfoPayload.current = {};
    setCandidateInfo(null);
    setIncompleteCandidates([]);
    setSelectedCandidate(null);
    setSchedule(null);
    setCandidateLoadError(false);
    setCandidatesLoading(false);
    setIsLoading(false);
    setIsQuietLoading(false);
  }, [candidateContextKey]);

  useEffect(() => {
    reduxDateRef.current = activeReduxDate || reduxDate;
  }, [activeReduxDate, reduxDate]);

  useEffect(() => {
    const hasConcreteInterviewDate =
      activeReduxDate &&
      !isPrescreenInterviewDate(activeReduxDate) &&
      activeReduxDate.DateOfInterview &&
      activeReduxDate.StartTime;

    if (activeReduxDate && getInterviewDatePk(activeReduxDate) != null && dContext && dContext.department) {
      if (getInterviewDatePk(activeReduxDate) !== previousDate) {
        previousDateIsDifferentRef.current = true;
      } else {
        previousDateIsDifferentRef.current = false;
      }

      setPreviousDate(getInterviewDatePk(activeReduxDate));
      // const day = dayjs().format('MM/DD/YYYY'); OLD
      const day = dayjs.tz(dayjs(), dContext.department.TimeZone).format('MM/DD/YYYY');

      if (isPrescreenInterviewDate(activeReduxDate)) {
        setInterviewIsToday(false);
        setInterviewHasPassed(false);
      } else if (hasConcreteInterviewDate) {
        const interviewDate = dayjs.tz(
          `${activeReduxDate.DateOfInterview} ${activeReduxDate.StartTime}`,
          dContext.department.TimeZone,
        );
        if (day === interviewDate.format('MM/DD/YYYY')) {
          setInterviewIsToday(true);
        } else {
          setInterviewIsToday(false);
        }
        const isInPast = interviewDate.diff(dayjs(new Date(day)));
        if (isInPast < 0) {
          setInterviewHasPassed(true);
        } else {
          setInterviewHasPassed(false);
        }
      } else {
        setInterviewIsToday(false);
        setInterviewHasPassed(false);
      }

      if (hasConcreteInterviewDate || isPrescreenInterviewDate(activeReduxDate)) {
        getAdjacentSchedule(reduxDateArray || [], activeReduxDate);
      }
    }
    const isAdminAndEvaluatorSelected = isAdmin && pk_User;

    if (activeReduxDate && (isAdminAndEvaluatorSelected || !isAdmin)) {
      // console.log('useEffect getInfo1');
      getInfo(false);
      getNeedsAttention();
    } else if (activeReduxDate) {
      // console.log('useEffect getInfo2');
      getInfo(false);
    }
  }, [candidateContextKey, reduxDateArray]);

  useEffect(() => {
    // console.log('allDayRoom setReduxDate: ', clone(reduxDate));
    const normalizedDate = normalizeInterviewDate(reduxDate, reduxDateArray);
    const currentReduxDatePk = normalizeInterviewDatePk(getInterviewDatePk(reduxDate));
    const normalizedDatePk = normalizeInterviewDatePk(getInterviewDatePk(normalizedDate));

    if (
      normalizedDate &&
      allDayRoom != null &&
      currentReduxDatePk === normalizedDatePk &&
      reduxDate &&
      reduxDate.allDayRoom !== allDayRoom
    ) {
      setReduxDate({ ...normalizedDate, allDayRoom: allDayRoom });
    }
  }, [allDayRoom, reduxDate, reduxDateArray, setReduxDate]);

  useEffect(() => {
    activeTabRef.current = activeTab;
    if (activeTab === '1' && indexesWithDifferences && !highlightIsFading) {
      setHighlightIsFading(true);
      setTimeout(() => {
        setIndexesWithDifferences([]);
        setHighlightIsFading(false);
      }, 10000);
    }
  }, [activeTab]);

  useEffect(() => {
    highlightIsFadingRef.current = highlightIsFading;
  }, [highlightIsFading]);

  useEffect(() => {
    let minutesToWait = 2 * 60 * 1000;
    if (isPrescreen) {
      minutesToWait = 10 * 60 * 1000;
    }
    setMinutes(minutesToWait);
    // setMinutes(65000);
    setMinutesToUpdateToDisplay(minutesToWait);
    minutesToUpdateToDisplayRef.current = minutesToWait;
    if (updateIntervalRef.current) {
      clearInterval(updateIntervalRef.current);
    }
    updateIntervalRef.current = setInterval(() => {
      const { isQuietLoading, isLoading } = loadingRef.current;
      if (!isLoading && !isQuietLoading) {
        getInfo(true);
      } else {
        // console.log('still fetching, cancel update');
      }
    }, minutesToWait);

    return () => {
      if (updateIntervalRef.current) {
        clearInterval(updateIntervalRef.current);
        updateIntervalRef.current = null;
      }
    };
  }, [candidateContextKey, isPrescreen, selectedEvaluator]);

  // //if the user changes reset the candidante info
  useEffect(() => {
    // console.log('pk_User change!: ', pk_User);
    setCandidateInfo(null);
    setSelectedCandidate(null);

    if (pk_User != null || !isAdmin) {
      getNeedsAttention(reduxDate);
    }
    pk_UserRef.current = pk_User;
  }, [pk_User, isAdmin]);

  useEffect(() => {
    if (selectedCandidateId) {
      updateSelectedTimeSlotFromSelectedCandidate(selectedCandidateId);
    }
  }, [selectedCandidateId]);

  useEffect(() => {
    // if admin is selected but here's no pk_User don't fetch - Admin needs a user to select
    if (isAdmin && !pk_User) return;

    if (dContext && dContext.department && dContext.department.pk_Department) {
      getTokenSilently()
        .then((token) => {
          fetchDataAgnostic(
            'department/user',
            { pk_Department: dContext.department.pk_Department, pk_User, isAdmin },
            formatBearerToken(token),
          )
            .then((result) => {
              setUser(result.data);
              setUserInformation(result.data);
            })
            .catch((err) => {});
        })
        .catch((err) => {
          checkLoginForError({ err, loginWithRedirect });
        });
    }
  }, [dContext, pk_User]);

  useEffect(() => {
    // Updates reduxDateArray when selected user or date is changed
    const validatepk_UserIfAdmin = (isAdmin && pk_User) || !isAdmin;
    // console.log('popping! ');
    // console.log('dContext: ', clone(dContext));
    // console.log('reduxDate: ', clone(reduxDate));
    // console.log('pk_User: ', pk_User);
    // console.log('isAdmin: ', isAdmin);
    // console.log('validatepk_UserIfAdmin:  ', validatepk_UserIfAdmin);
    // console.log('selectedEvaluator: ', selectedEvaluator);
    if (
      dContext &&
      dContext.department &&
      dContext.season &&
      dContext.department.pk_Department &&
      (getInterviewDatePk(reduxDate) == null || reduxDateArray.length <= 0) &&
      validatepk_UserIfAdmin &&
      !isFetchingReduxDateArray
    ) {
      setIsFetchingReduxDateArray(true);
      // setTimeout(() => {
      getTokenSilently()
        .then((token) => {
          fetchDataAgnostic(
            'department/season/user/scheduledates',
            {
              pk_Department: dContext.department.pk_Department,
              pk_Season: dContext.season.pk_Season,
              isAdmin,
              pk_User,
            },
            formatBearerToken(token),
          )
            .then((result) => {
              setIsDateListLoaded(true);
              const datesSortedByEarliest = result.data.sort((a, b) => {
                const firstMillis = dayjs(a.DateTimeObject).valueOf();
                const secondMillis = dayjs(b.DateTimeObject).valueOf();

                if (firstMillis < secondMillis) {
                  return -1;
                }
                if (firstMillis > secondMillis) {
                  return 1;
                }
                // a must be equal to b
                return 0;
              });

              if (JSON.stringify(reduxDateArray) !== JSON.stringify(datesSortedByEarliest)) {
                // console.log('setReduxDateArray: ', datesSortedByEarliest);
                setReduxDateArray(datesSortedByEarliest);
              }

              // Maybe this isn't needed here? Seems redundant with the other useEffect up top.
              return;
            })
            .catch((err) => {})
            .finally(() => {
              setIsFetchingReduxDateArray(false);
            });
        })
        .catch((err) => {
          checkLoginForError({ err, loginWithRedirect });
        });
      // }, 10000);
    }
  }, [dContext, pk_User, reduxDate]);

  useEffect(() => {
    //TODO: Find a better way to wait for notifications to mount rather than just setting a timeout
    const handleActivity = () => {
      const now = dayjs();
      localStorage.setItem('lastActivity', now.toISOString());
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
      setIsMobile(isEvaluatorHeaderMobile(window.innerWidth));
    };

    headerMeasureTimeoutRef.current = setTimeout(() => {
      const heightOfHeader = document.getElementById('header_notification_wrapper');
      if (heightOfHeader) {
        setHeightOfHeader(heightOfHeader.offsetHeight);
      }
    }, 1000);
    getDataTypes();

    countdownIntervalRef.current = setInterval(() => {
      if (minutesToUpdateToDisplayRef.current > 0) {
        setMinutesToUpdateToDisplay(minutesToUpdateToDisplayRef.current - 1000);
        minutesToUpdateToDisplayRef.current = minutesToUpdateToDisplayRef.current - 1000;
      }
    }, 1000);

    document.addEventListener('mousemove', handleActivity);
    document.addEventListener('click', handleActivity);

    checkInactivity(true);

    inactivityIntervalRef.current = setInterval(() => {
      checkInactivity();
    }, 10000);

    window.addEventListener('resize', handleResize);

    return () => {
      clearAll();
      document.removeEventListener('mousemove', handleActivity);
      document.removeEventListener('click', handleActivity);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    if (!loggedInUser && !isGettingLoggedInUser && dContext) {
      getCurrentlyLoggedInUser();
    }
  }, [dContext]);

  useEffect(() => {
    if (schedule) {
      getScheduleStartAndEndTime(schedule);
    }
  }, [schedule]);

  useEffect(() => {
    // if (scheduleStartTime && scheduleEndTime) {
    //   console.log('scheduleStartTime: ', scheduleStartTime.current.format('MMM DD hh:mm A'));
    //   console.log('scheduleEndTime: ', scheduleEndTime.current.format('MMM DD hh:mm A'));
    // }
  }, [scheduleStartTime, scheduleEndTime]);

  const getScheduleStartAndEndTime = (scheduleToProcess) => {
    let newStartTime = null;
    let newEndTime = null;

    if (scheduleToProcess && scheduleToProcess.length > 0) {
      let index = 0;

      while (newStartTime === null && index < scheduleToProcess.length) {
        const scheduleRow = scheduleToProcess[index];

        if (!scheduleRow.isRedirect && scheduleRow.StartTime) {
          newStartTime = scheduleRow.StartTimeAsMoment;
        }
        index++;
      }

      index = scheduleToProcess.length - 1;

      while (newEndTime === null && index >= 0) {
        const scheduleRow = scheduleToProcess[index];

        if (!scheduleRow.isRedirect && scheduleRow.EndTime) {
          newEndTime = scheduleRow.EndTimeAsMoment;
        }
        index--;
      }

      scheduleStartTime.current = newStartTime;
      scheduleEndTime.current = newEndTime;
    }
  };

  const getCurrentlyLoggedInUser = () => {
    setIsGettingLoggedInUser(true);
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic('department/user/permissions', null, formatBearerToken(token))
          .then((res) => {
            setIsGettingLoggedInUser(false);
            setLoggedInUser(res.data);
          })
          .catch((err) => {
            setIsGettingLoggedInUser(false);
            console.log('getUserDetails err: ', err);
          });
      })
      .catch((err) => {
        setIsGettingLoggedInUser(false);
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const clearAll = () => {
    // console.log('clearing Mobile Fork!');
    oldGetInfoPayload.current = {};
    previousDateIsDifferentRef.current = true;
    hasFiredInactivityPopupRef.current = false;
    setReduxDate({});
    reduxDateRef.current = null;
    adjacentDatesRef.current = [];
    // setReduxDateArray([]);
    setUserInformation(null);
    if (headerMeasureTimeoutRef.current) {
      clearTimeout(headerMeasureTimeoutRef.current);
      headerMeasureTimeoutRef.current = null;
    }
    if (countdownIntervalRef.current) {
      clearInterval(countdownIntervalRef.current);
      countdownIntervalRef.current = null;
    }
    if (inactivityIntervalRef.current) {
      clearInterval(inactivityIntervalRef.current);
      inactivityIntervalRef.current = null;
    }
    if (updateIntervalRef.current) {
      clearInterval(updateIntervalRef.current);
      updateIntervalRef.current = null;
    }
    setUser(null); // This is a redux thing. Reset user when unloading. Otherwise it will show the previous user when MobileFork us used on a different page
  };

  const dayjsizeUnavailableTimes = (result) => {
    if (result.data && result.data && result.data.body) {
      result.data.body.forEach((item) => {
        item.UnavailableOverlaps.forEach((unavailable) => {
          const startTimeFormatted = dayjs(unavailable.StartTime).format('H:mma');
          const endTimeFormatted = dayjs(unavailable.EndTime).format('H:mma');
          unavailable.StartTimeFormatted = startTimeFormatted;
          unavailable.EndTimeFormatted = endTimeFormatted;
        });
      });
    }
  };

  //TODO: depreacte this. Logic has been moved to Evaluation.js
  const checkIfEvalsAreLocked = () => {
    return false;
    if (lockedStatuses) {
      const { EnablePrescreenQuestionnaire, EnableEvaluationQuestionnaire } = lockedStatuses;

      const isPrescreen = isPrescreenInterviewDate(reduxDate);

      if (isPrescreen && EnablePrescreenQuestionnaire !== true) {
        return true;
      }
      if (!isPrescreen && EnableEvaluationQuestionnaire !== true) {
        return true;
      }
    }
    return false;
  };

  // const { getRemainingTime, getLastActiveTime, reset } = useIdleTimer({
  //   timeout: 30 * 60 * 1000,
  //   onIdle: handleOnIdle,
  //   onActive: handleOnActive,
  //   onAction: handleOnAction,
  //   debounce: 500,
  // });

  const getAdjacentSchedule = (dates, currentDate) => {
    const newAdjacentDates =
      dates.filter((d) => {
        // console.log(`d ${d.DateOfInterview} vs current ${currentDate.DateOfInterview}`);
        return d.DateOfInterview === currentDate.DateOfInterview;
        // && d.pk_InterviewDate != currentDate.pk_InterviewDate;
      }) || [];

    setAdjacentDates(newAdjacentDates);
    adjacentDatesRef.current = newAdjacentDates;
  };

  // Keep results scoped to the current program, season, evaluator and date. A slower
  // previous request must not replace a newer list or its loading/error state.
  const loadCandidateList = async (payload, quietly = false) => {
    const requestId = ++candidateRequestRef.current;
    const contextKey = candidateContextKey;
    const isCurrent = () => candidateContextRef.current === contextKey && candidateRequestRef.current === requestId;
    setCandidateLoadError(false);
    setCandidatesLoading(!quietly && candidateInfo == null);
    setIsQuietLoading(!!quietly);
    try {
      const token = await getTokenSilently();
      if (!isCurrent()) return;
      const result = await fetchDataAgnostic(
        'department/season/user/scheduledate/candidates',
        payload,
        formatBearerToken(token),
      );
      if (!isCurrent()) return;
      sortCandidates(currentCandidateSortType, false, result.data);
      setMinutesToUpdateToDisplay(minutes);
      minutesToUpdateToDisplayRef.current = minutes;
    } catch (err) {
      if (!isCurrent()) return;
      setCandidateLoadError(true);
      checkLoginForError({ err, loginWithRedirect });
    } finally {
      if (isCurrent()) {
        setCandidatesLoading(false);
        setIsQuietLoading(false);
      }
    }
  };

  const getPrescreen = (quietly) => {
    if (!allowPrescreen || !dContext || !dContext.department || !dContext.season) return;
    if (isAdmin && (!selectedEvaluator || selectedEvaluator.pk_User == null)) return;
    const payload = {
      pk_Department: dContext.department.pk_Department,
      pk_Season: dContext.season.pk_Season,
      mode: 'Prescreen',
      context: 'evaluator',
    };
    if (selectedEvaluator && selectedEvaluator.pk_User != null) {
      payload.pk_User = selectedEvaluator.pk_User;
      payload.isAdmin = 1;
    }
    return loadCandidateList(payload, quietly);
  };

  const handleZoomClick = (options) => {
    const { url, mobileNumbers, password, meetingId, nonZoomInfo, preOpenedWindow = null } = options;
    const pendingVideoWindow = preOpenedWindow || preOpenNamedMeetingWindow(REZRATE_VIDEO_WINDOW_TARGET);

    // if there are mobile numbers set them.  If not,
    // make sure zoom info resets so it doesn't display
    // info from previous meeting
    if (password && password !== '') {
      setZoomPassword(password);
    } else {
      setZoomPassword('');
    }

    if (meetingId && meetingId !== '') {
      setMeetingId(meetingId);
    } else {
      setMeetingId('');
    }

    if (mobileNumbers && mobileNumbers.length > 0) {
      setZoomInfo(mobileNumbers);
    } else {
      setZoomInfo([]);
    }

    if (nonZoomInfo && nonZoomInfo !== '') {
      setNonZoomInfo(nonZoomInfo);
    } else {
      setNonZoomInfo('');
    }
    const zoomLinkWrapped = urlWithHttpProtocol(url);
    localStorage.setItem('zoomUrl', zoomLinkWrapped);
    setMeetingLink(zoomLinkWrapped);
    setShowMeetingCard(true);
    setTimeout(() => {
      openURLInNewTab(zoomLinkWrapped, pendingVideoWindow);
    }, 1000);

    setTimeout(() => {
      setShowMeetingCard(false);
    }, 3 * 60 * 1000);
  };

  const openURLInNewTab = (urlFormatted, preOpenedWindow = null) => {
    if (!urlFormatted) {
      if (preOpenedWindow) {
        try {
          if (!preOpenedWindow.closed) {
            preOpenedWindow.close();
          }
        } catch (error) {
          // ignore close errors
        }
      }
      return false;
    }
    const opened = openUrlInNewTabOrDetectBlock(urlFormatted, REZRATE_VIDEO_WINDOW_TARGET, preOpenedWindow);
    if (!opened) {
      if (preOpenedWindow) {
        try {
          if (!preOpenedWindow.closed) {
            preOpenedWindow.close();
          }
        } catch (error) {
          // ignore close errors
        }
      }
      Swal.fire('Error!', 'Please allow RezRATE to open the meeting window.', 'error');
      return false;
    }
    return true;
  };
  const informUserMeetingIsStartingLocally = (setDisplayLocalNotification) => {
    setDisplayLocalNotification(false);
    setTimeout(() => {
      setDisplayLocalNotification(true);
    }, 3 * 60 * 1000);
    toast.info('Time for next meeting: Click here to join!', {
      autoClose: 10 * 1000,
      onClick: () => {
        if (
          typeof Schedules4EvalJoinManualURL !== 'undefined' &&
          Schedules4EvalJoinManualURL !== '' &&
          Schedules4EvalJoinManualURL !== null
        ) {
          handleZoomClick({ url: Schedules4EvalJoinManualURL });
        } else {
          requestZoomMeeting(Schedules4Eval__pkUUID_Schedule);
        }
      },
    });
  };

  const sortCandidatesAlphabetically = (incomingCandidates, isIncompleteCandidates, direction = 'asc') => {
    const sortAscending = direction === 'asc';
    let newCandidates = clone(incomingCandidates || candidateInfo || []);

    if (isIncompleteCandidates) {
      newCandidates = clone(incomingCandidates || incompleteCandidates);
    }

    newCandidates.sort((a, b) => {
      const textA = `${a.LastName}, ${a.FirstName}`;
      const textB = `${b.LastName}, ${b.FirstName}`;
      if (sortAscending) {
        return textA < textB ? 1 : textA > textB ? -1 : 0;
      } else {
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      }
    });

    setCurrentCandidateSortType(candidateSortTypes.Alphabetical);

    if (isIncompleteCandidates) {
      setIncompleteCandidates(newCandidates);
      return;
    }

    setCandidateInfo(newCandidates);
    return;
  };

  const sortByUniversity = (incomingCandidates, isIncompleteCandidates, direction = 'asc') => {
    const sortAscending = direction === 'asc';

    if (isIncompleteCandidates) {
      setIncompleteCandidates((prevState) => {
        const candidates = clone(incomingCandidates || prevState);
        const sortedByAlphabet = sortAlphabetically(candidates);
        return sortedByAlphabet.sort(function(a, b) {
          const textA = `${a.CandidateSubHeading || ''}`;
          const textB = `${b.CandidateSubHeading || ''}`;
          const nameA = `${a.LastName}, ${a.FirstName}`;
          const nameB = `${b.LastName}, ${b.FirstName}`;

          if (sortAscending) {
            return textA < textB ? 1 : textA > textB ? -1 : nameA < nameB ? 1 : nameB < nameA ? -1 : 0;
          } else {
            return textA < textB ? -1 : textA > textB ? 1 : nameA > nameB ? 1 : nameB > nameA ? -1 : 0;
          }
        });
      });
    } else {
      setCandidateInfo((prevState) => {
        const candidates = incomingCandidates ?? prevState;
        const sortedByAlphabet = sortAlphabetically(candidates);
        return sortedByAlphabet.sort(function(a, b) {
          const textA = `${a.MedicalSchoolOfGraduation || ''}`;
          const textB = `${b.MedicalSchoolOfGraduation || ''}`;
          const nameA = `${a.LastName}, ${a.FirstName}`;
          const nameB = `${b.LastName}, ${b.FirstName}`;
          if (sortAscending) {
            return textA < textB ? 1 : textA > textB ? -1 : nameA < nameB ? 1 : nameB < nameA ? -1 : 0;
          } else {
            return textA < textB ? -1 : textA > textB ? 1 : nameA > nameB ? 1 : nameB > nameA ? -1 : 0;
          }
        });
      });
    }

    setCurrentCandidateSortType(candidateSortTypes.University);
  };

  const sortAlphabetically = (candidates, isIncompleteCandidates) => {
    return candidates.sort(function(a, b) {
      if (a.Candidates4DateNameLast < b.Candidates4DateNameLast) {
        return -1;
      } else if (a.Candidates4DateNameLast > b.Candidates4DateNameLast) {
        return 1;
      }
      return 0;
    });
  };

  const sortByEvalStatus = (incomingCandidates, isIncompleteCandidates, direction = 'asc') => {
    const sortAscending = direction === 'asc';

    if (isIncompleteCandidates) {
      setIncompleteCandidates((prevState) => {
        const candidates = clone(incompleteCandidates);
        const sortedByAlphabet = sortAlphabetically(candidates);
        const valueToReturn = sortedByAlphabet.sort(function(a, b) {
          const aStatus = a.Status || '';
          const bStatus = b.Status || '';
          if (aStatus.split(' ')[0].length < bStatus.split(' ')[0].length) {
            if (sortAscending) {
              return -1;
            } else {
              return 1;
            }
          }
          if (aStatus.split(' ')[0].length > bStatus.split(' ')[0].length) {
            if (sortAscending) {
              return 1;
            } else {
              return -1;
            }
          }
          return 0;
        });
        return valueToReturn;
      });
    } else {
      setCandidateInfo((prevState) => {
        const candidates = incomingCandidates ?? prevState;
        const sortedByAlphabet = sortAlphabetically(candidates);
        const valueToReturn = sortedByAlphabet.sort(function(a, b) {
          const aStatus = a.Status || '';
          const bStatus = b.Status || '';
          if (aStatus.split(' ')[0].length < bStatus.split(' ')[0].length) {
            if (sortAscending) {
              return -1;
            } else {
              return 1;
            }
          }
          if (aStatus.split(' ')[0].length > bStatus.split(' ')[0].length) {
            if (sortAscending) {
              return 1;
            } else {
              return -1;
            }
          }
          return 0;
        });
        return valueToReturn;
      });
    }

    setCurrentCandidateSortType(candidateSortTypes.EvalStatus);
  };

  const sortCandidates = (
    type,
    isIncompleteCandidates = false,
    listToUse,
    direction = sortCandAscending ? 'asc' : 'desc',
  ) => {
    if (direction != null) {
      setSortCandAscending(direction === 'asc' ? true : false);
    }

    if (type === candidateSortTypes.Alphabetical) {
      sortCandidatesAlphabetically(listToUse || null, isIncompleteCandidates, direction);
    } else if (type === candidateSortTypes.EvalStatus) {
      sortByEvalStatus(listToUse || null, isIncompleteCandidates, direction);
    } else if (type === candidateSortTypes.University) {
      sortByUniversity(listToUse || null, isIncompleteCandidates, direction);
    }
  };

  // Get candidate list for Candidates tab
  const getCandidateForDate = (pk_Department, pk_Season, pk_InterviewDate, quietly = false) => {
    if (isAdmin && !pk_User) return;
    if (!dContext || !dContext.department || !dContext.season || !reduxDate) return;
    if (isPrescreen) return getPrescreen(quietly);
    return loadCandidateList({
      pk_Department: pk_Department || dContext.department.pk_Department,
      pk_Season: pk_Season || dContext.season.pk_Season,
      pk_InterviewDate: pk_InterviewDate || reduxDate.pk_InterviewDate,
      pk_User,
      isAdmin,
      allCandidatesForDate: true,
      mode: 'Evaluation',
      context: 'evaluator',
    }, quietly);
  };

  // Get candidate list for Incomplete
  const getNeedsAttention = () => {
    if (!dContext || !dContext.department || !dContext.season) {
      return;
    }
    const contextKey = candidateContextKey;
    const payload = {
      pk_Department: dContext.department.pk_Department,
      pk_Season: dContext.season.pk_Season,
      // pk_InterviewDate: date.pk_InterviewDate,
      mode: isPrescreen ? 'Prescreen' : 'Evaluation',
      attentionNeeded: 1,
      context: 'evaluator',
    };

    if (selectedEvaluator && selectedEvaluator.pk_User) {
      payload.pk_User = selectedEvaluator.pk_User;
      payload.isAdmin = 1;
    }

    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic('department/season/user/scheduledate/candidates', payload, formatBearerToken(token))
          .then((res) => {
            if (candidateContextRef.current !== contextKey) return;
            sortCandidates(currentCandidateSortType, true, res.data);
          })
          .catch((err) => {
            console.log('err: ', err);
          });
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  // Gets schedule
  const getInfo = (quietly) => {
    // console.log('getInfo firing! quietly: ', quietly);
    // console.log('getInfo reduxDateRef.current: ', clone(reduxDateRef.current));
    // console.log('getInfo pk_User: ', pk_User);
    // console.log('getInfo isAdmin: ', isAdmin);
    // console.log('getInfo reduxDate: ', reduxDate);

    const contextKey = candidateContextKey;
    if (!dContext || !dContext.season || !dContext.department) {
      // console.log('no dContext data!');
      return;
    }

    if (!reduxDateRef.current) {
      // console.log('no reduxDate!');
      setIsLoading(false);
      setIsQuietLoading(false);
      setMinutesToUpdateToDisplay(minutes);
      minutesToUpdateToDisplayRef.current = minutes;
      return;
    }

    if (isPrescreen || isPrescreenRef.current) {
      // console.log("isPrescreen, don't fetch");

      setSchedule(null);
      getPrescreen(quietly);
      setMinutesToUpdateToDisplay(minutes);
      minutesToUpdateToDisplayRef.current = minutes;
      return;
    }

    // if admin is accessing this page and no user is selected, don't fetch
    if (isAdmin && !pk_User) {
      setIsLoading(false);
      setIsQuietLoading(false);
      setMinutesToUpdateToDisplay(minutes);
      setSchedule(null);
      minutesToUpdateToDisplayRef.current = minutes;
      return;
    }

    if (reduxDateRef.current && reduxDateRef.current.pk_InterviewDate) {
      const { pk_InterviewDate } = reduxDateRef.current;

      const newPayload = {
        pk_Department: dContext.department.pk_Department,
        pk_InterviewDate: pk_InterviewDate,
        pk_User,
        isAdmin,
      };

      let payloadHasDifference = false;

      Object.keys(newPayload).forEach((key) => {
        if (newPayload[key] != oldGetInfoPayload.current[key]) {
          payloadHasDifference = true;
        }
      });

      if (!payloadHasDifference && !quietly) {
        // console.log("getInfo cancelled, payload hasn't changed");
        setIsLoading(false);
        setMinutesToUpdateToDisplay(minutes);
        minutesToUpdateToDisplayRef.current = minutes;
        return;
      } else {
        oldGetInfoPayload.current = newPayload;
      }

      if (!quietly) {
        setIsLoading(true);
      } else {
        setIsQuietLoading(true);
      }
      setError(false);
      // console.log('getInfo firing');
      // setSchedule(null);

      getTokenSilently()
        .then((token) => {
          if (candidateContextRef.current !== contextKey) return;
          fetchDataAgnostic(
            'department/season/interviewDate/user/schedule',
            { pk_Department: dContext.department.pk_Department, pk_InterviewDate: pk_InterviewDate, pk_User, isAdmin },
            formatBearerToken(token),
          )
            .then((result) => {
              if (candidateContextRef.current !== contextKey) return;
              if (
                (reduxDateRef.current && reduxDateRef.current.pk_InterviewDate != pk_InterviewDate) ||
                pk_User != pk_UserRef.current
              ) {
                return;
              }

              setMinutesToUpdateToDisplay(minutes);
              minutesToUpdateToDisplayRef.current = minutes;

              const { flexEvents = [] } = result.data || {};

              if (result.data) {
                if (result.data.virtualMeetingMode) {
                  setVirtualMeetingMode(result.data.virtualMeetingMode);
                }

                setEnableEmbeddedMeetings(Boolean(result.data.enableEmbeddedMeetings));

                if (result.data.firstBlockEarlyJoinInMinutes != null) {
                  setFirstBlockEarlyJoinInMinutes(result.data.firstBlockEarlyJoinInMinutes);
                }
              }

              dayjsizeUnavailableTimes(result);
              if (result.data && result.data && result.data.metaData) {
                const {
                  EnableEvaluationQuestionnaire,
                  EnableHiddenStatus,
                  EnableLockedStatus,
                  EnablePrescreenQuestionnaire,
                  MainRoomURL,
                  MainRoomURLDetails,
                } = result.data.metaData;
                setLockedStatuses({
                  EnableEvaluationQuestionnaire,
                  EnableHiddenStatus,
                  EnableLockedStatus,
                  EnablePrescreenQuestionnaire,
                });
                setAllDayRoom(MainRoomURL);
                setMainRoomUrlDetails(MainRoomURLDetails);
              }

              result.data.body.forEach((item) => {
                const { EndTime, StartTime } = item;
                item.EndTimeAsMoment = dayjs(EndTime);
                item.StartTimeAsMoment = dayjs(StartTime);
              });

              setAlarms(result.data.alertsResults);
              setSchedule((prevState) => {
                const arrayEqual = isArrayEqual(result.data.body, prevState, ['StartTime', 'EndTime']);
                const { dateBefore, dateAfter, sameDates } = processAdjacentDates(adjacentDatesRef.current);

                const newIndexesWithDifferences =
                  isEmbedded || previousDateIsDifferentRef.current
                    ? []
                    : getArrayIndexesWithDifferencesViaTimeSlot(
                        result.data.body || [],
                        prevState || [],
                        ['Candidates'],
                        [],
                        activeTabRef.current === '1' ? [] : indexesWithDifferences,
                      );

                if (newIndexesWithDifferences && newIndexesWithDifferences.length > 1) {
                  setIndexesWithDifferences(newIndexesWithDifferences); // Only overwrite existing, if there are new changes. Only by clicking OK in SWAL should we remove highlight
                  setHighlightIsFading(false);
                  if (activeTabRef.current === '1' && !highlightIsFadingRef.current) {
                    setHighlightIsFading(true);
                    Swal.fire({
                      title: 'Schedule has been updated',
                      text: 'Changes are highlighted!',
                    }).then(() => {
                      setShowRed(true);
                      setTimeout(() => {
                        setShowRed(false);
                        setIndexesWithDifferences([]);
                        setHighlightIsFading(false);
                      }, 10 * 1000);
                    });
                  } else {
                    toast.info('Schedule has been updated!');
                  }
                }
                setDifferences(arrayEqual);

                const newBody = result.data.body;

                // if (newBody.length > 0) {
                if (dateBefore) {
                  newBody.splice(0, 0, { isRedirect: true, interviewDate: dateBefore, type: 'before' });
                }

                if (dateAfter) {
                  newBody.push({ isRedirect: true, interviewDate: dateAfter, type: 'after' });
                }

                if (sameDates && sameDates.length > 0) {
                  newBody.push({ isRedirect: true, interviewDates: sameDates, type: 'same' });
                }

                newBody.forEach((item) => {
                  if (item.isFlexEvent) {
                    item.FlexEvent = flexEvents.find((f) => f.pk_FlexEvent === item.pk_FlexEvent);
                  }
                });
                return newBody;
              });
              setIsLoading(false);
              setIsQuietLoading(false);
              minutesToUpdateToDisplayRef.current = minutes;
              // setTimeout(() => {
              //   setError(true);
              // }, 6000);
            })
            .catch((err) => {
              if (candidateContextRef.current !== contextKey) return;
              console.log('getInfo error: ', err);
              setError(true);
              // setSchedule(null);
              setIsLoading(false);
              setIsQuietLoading(false);
              minutesToUpdateToDisplayRef.current = minutes;
            });

          getCandidateForDate(dContext.department.pk_Department, dContext.season.pk_Season, pk_InterviewDate, quietly);
          // getNeedsAttention();
        })
        .catch((err) => {
          checkLoginForError({ err, loginWithRedirect });
        });
    } else {
      // console.log("reduxDateRef.current doesn't have pk_InterviewDate");
    }
  };

  const updateAttachedAdjacentDates = (body, newAdjacentDates) => {
    const { dateBefore, dateAfter, sameDates } = processAdjacentDates(newAdjacentDates);
    const newBody = clone(body);

    if (dateBefore) {
      newBody.splice(0, 0, { isRedirect: true, interviewDate: dateBefore, type: 'before' });
    }

    if (dateAfter) {
      newBody.push({ isRedirect: true, interviewDate: dateAfter, type: 'after' });
    }

    if (sameDates && sameDates.length > 0) {
      newBody.push({ isRedirect: true, interviewDates: sameDates, type: 'same' });
    }
    return newBody;
  };

  const processAdjacentDates = (forcedAdjacentDates) => {
    let dateBefore = null;
    let dateAfter = null;
    let sameDates = [];
    const adjacentDatesActual = forcedAdjacentDates ? forcedAdjacentDates : adjacentDates;

    const dateAvailable = reduxDate || {};
    if (adjacentDatesActual == null || adjacentDatesActual.length <= 0) {
      return { dateBefore, dateAfter, sameDates };
    }

    const currentDateIndex = adjacentDatesActual.findIndex((a) => {
      return a.pk_InterviewDate === dateAvailable.pk_InterviewDate;
    });

    if (currentDateIndex >= 0) {
      let x = currentDateIndex;
      while (x > 0 && dateBefore == null) {
        const tryDate = adjacentDatesActual[x - 1];
        const dStart = dayjs(`${tryDate.DateOfInterview} ${tryDate.StartTime}`);
        const dateStart = dayjs(`${dateAvailable.DateOfInterview} ${dateAvailable.StartTime}`);
        if (dStart.isBefore(dateStart)) {
          dateBefore = tryDate;
        } else if (tryDate.pk_InterviewDate != dateAvailable.pk_InterviewDate && dStart.isSame(dateStart)) {
          const sameDateContains = sameDates.find((d) => {
            return d.pk_InterviewDate === tryDate.pk_InterviewDate;
          });

          if (!sameDateContains) {
            sameDates.push(tryDate);
          }
        }
        x--;
      }

      x = currentDateIndex;

      while (x < adjacentDatesActual.length - 1 && dateAfter == null) {
        const tryDate = adjacentDatesActual[x + 1];

        const dStart = dayjs(`${tryDate.DateOfInterview} ${tryDate.StartTime}`);
        const dateStart = dayjs(`${dateAvailable.DateOfInterview} ${dateAvailable.StartTime}`);

        if (dStart.isAfter(dateStart)) {
          dateAfter = tryDate;
        } else if (tryDate.pk_InterviewDate != dateAvailable.pk_InterviewDate && dStart.isSame(dateStart)) {
          const sameDateContains = sameDates.find((d) => {
            return (
              d.pk_InterviewDate != dateAvailable.pk_InterviewDate && d.pk_InterviewDate === tryDate.pk_InterviewDate
            );
          });

          if (!sameDateContains) {
            sameDates.push(tryDate);
          }
        }
        x++;
      }
    }

    return { dateBefore, dateAfter, sameDates };
  };

  const checkIfStatusNeedsChangingToModify = (options) => {
    if (!dContext || !dContext.season || !dContext.department) {
      return;
    }
    const textValue = 'In progress';
    if (
      candidateEvaluationStatus &&
      candidateEvaluationStatus.Status &&
      (candidateEvaluationStatus.Status.toUpperCase() === 'COMPLETE' ||
        candidateEvaluationStatus.Status.toUpperCase() === 'UNABLE TO EVALUATE')
    ) {
      return Swal.fire({
        title: 'Do you want to modify this evaluation?',
        text: `Status will be changed from "Complete" to "${textValue}"`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(48, 133, 214)',
        confirmButtonText: `Modify`,
        cancelButtonColor: 'rgb(221, 51, 51)',
      }).then(async (result) => {
        if (result.value) {
          const token = await getTokenSilently();
          const dataChanged = await putData(
            'department/season/candidate/evaluation/status',
            {
              pk_Department: dContext.department.pk_Department,
              pk_Season: dContext.season.pk_Season,
              pk_User,
              selectedCandidateId: selectedCandidate.pk_Candidate,
              isAdmin,
              status: 'InProgress',
              mode: isPrescreen ? 'Prescreen' : 'Evaluation',
            },
            null,
            formatBearerToken(token),
          );

          await getCandidateStatus(selectedCandidate.pk_Candidate, token);

          return true;
        }
        return false;
      });
    } else {
      return true;
    }
  };

  //TODO: deprecate this
  const requestZoomMeeting = (item) => {
    return;
  };

  const requestVirtualMeetingEvaluator = async (item) => {
    if (!dContext || !dContext.season || !dContext.department) {
      return null;
    }

    const { isFlexEvent, UrlType, isCustomMeeting, VirtualRoomType } = item;
    const isAllDayJoin = (isFlexEvent && UrlType === 'AllDay') || (isCustomMeeting && VirtualRoomType !== 'Custom');
    const meetingContext = createMeetingContext({
      department: dContext.department,
      season: dContext.season,
      item,
      interviewDateId: reduxDate?.pk_InterviewDate,
      isAllDay: isAllDayJoin,
    });
    const meetingOperationKey = getMeetingOperationKey(meetingContext, pk_User);
    const requestParams = buildEvaluatorMeetingParams(meetingContext, pk_User);

    activeEvaluatorMeetingKeyRef.current = meetingOperationKey;

    try {
      const token = await getTokenSilently();
      const result = await resolveMeetingWithRetry({
        contextKey: meetingOperationKey,
        inFlightOperations: evaluatorMeetingOperationsRef.current,
        requestMeeting: () => {
          return fetchDataAgnostic(
            'department/season/block/evaluator/meeting',
            requestParams,
            formatBearerToken(token),
          );
        },
        isContextCurrent: () => {
          return activeEvaluatorMeetingKeyRef.current === meetingOperationKey;
        },
      });

      if (result.isStale) {
        return null;
      }

      if (result.isPending) {
        throw new Error('This meeting is still being prepared. Please try again in a moment.');
      }

      return result.response;
    } catch (err) {
      checkLoginForError({ err, loginWithRedirect });
      throw err;
    }
  };

  // Each response belongs to a selection AND a context, not just a schedule slot.
  // Separate counters also reject older refreshes of the same selected candidate.
  const captureCandidateRequest = (id, kind, selectionVersion = renderedSelectionVersion) => {
    const contextKey = candidateContextKey;
    // Obsolete callbacks must neither issue a request nor invalidate a newer one.
    if (candidateContextRef.current !== contextKey || candidateSelectionRef.current.version !== selectionVersion || candidateSelectionRef.current.id !== id) {
      return () => { return false; };
    }
    const requestId = ++candidateSelectionRef.current[kind];
    return () => {
      return (
        candidateContextRef.current === contextKey &&
        candidateSelectionRef.current.version === selectionVersion &&
        candidateSelectionRef.current.id === id &&
        candidateSelectionRef.current[kind] === requestId
      );
    };
  };

  const getCandidateStatus = (id, token, selectionVersion = renderedSelectionVersion) => {
    const isCurrentRequest = captureCandidateRequest(id, 'status', selectionVersion);
    if (!isCurrentRequest()) return Promise.resolve();
    return fetchDataAgnostic(
      'department/candidate/evalStatus',
      {
        pk_Department: dContext.department.pk_Department,
        pk_Candidate: id,
        pk_User,
        isAdmin,
        mode: isPrescreen ? 'Prescreen' : 'Evaluation',
      },
      formatBearerToken(token),
    )
      .then((result) => {
        if (isCurrentRequest()) {
          const status = result?.data?.Status ? result.data : '';
          // An empty response is not authoritative over a valid evaluation fallback.
          if (!status) return;
          candidateSelectionRef.current.appliedStatusVersion += 1;
          setCandidateEvaluationStatus(status);
          setDNRStatus(status.EnableDoNotRank);
        }
      })
      .catch((err) => {});
  };

  const getCandidateDetails = (id, quietly, selectionVersion = renderedSelectionVersion) => {
    if (!dContext || !dContext.season || !dContext.department) {
      return;
    }
    const isCurrentRequest = captureCandidateRequest(id, 'details', selectionVersion);
    if (!isCurrentRequest()) return;
    if (!quietly) {
      setSelectedCandidate('fetching');
    }

    getTokenSilently()
      .then((token) => {
        if (!isCurrentRequest()) return;
        let candidate = fetchDataAgnostic(
          'department/candidate',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Candidate: id,
            context: 'evaluator',
            // pk_User, isAdmin
          },
          formatBearerToken(token),
        );

        getCandidateStatus(id, token, selectionVersion);

        Promise.all([candidate])
          .then((result) => {
            if (isCurrentRequest()) {
              setSelectedCandidate(result[0].data);
            }
          })
          .catch((err) => {
            if (isCurrentRequest()) {
              console.log('get candidate err: ', err);
            }
          });
      })
      .catch((err) => {
        if (isCurrentRequest()) {
          checkLoginForError({ err, loginWithRedirect });
        }
      });
  };

  const updateSelectedTimeSlotFromSelectedCandidate = (candidateToFind) => {
    let newTimeSlot = null;
    if (schedule) {
      let scheduleIndex = 0;

      while (scheduleIndex < schedule.length && newTimeSlot == null) {
        const row = schedule[scheduleIndex];
        const { Candidates } = row;

        if (Candidates) {
          let candidateIndex = 0;
          while (candidateIndex < Candidates.length && newTimeSlot == null) {
            const c = Candidates[candidateIndex];
            if (newTimeSlot == null && c.pk_Candidate == candidateToFind) {
              newTimeSlot = row;
            }
            candidateIndex++;
          }
        }
        scheduleIndex++;
      }
    }

    if (newTimeSlot) {
      setSelectedTimeSlot(clone(newTimeSlot));
    }
  };

  const getCandidateEvaluation = async (id, forcedDate, selectionVersion = renderedSelectionVersion) => {
    if (!dContext || !dContext.season || !dContext.department) {
      return;
    }

    // console.log('forcedDate: ', forcedDate);
    // console.log('reduxDate: ', reduxDate.pk_InterviewDate);
    // console.log('isPrescreen: ', isPrescreen);
    let dateToUse = forcedDate ? forcedDate : isPrescreen ? null : reduxDate ? reduxDate.pk_InterviewDate : null;

    const candidateId = id || selectedCandidateId;
    const isCurrentRequest = captureCandidateRequest(candidateId, 'evaluation', selectionVersion);
    const appliedStatusVersion = candidateSelectionRef.current.appliedStatusVersion;

    return getTokenSilently()
      .then((token) => {
        if (!isCurrentRequest()) return {};
        return fetchDataAgnostic(
          'department/season/candidate/evaluation',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Candidate: candidateId,
            pk_Season: dContext.season.pk_Season,
            // pk_InterviewDate: reduxDate.pk_InterviewDate,
            pk_User,
            isAdmin,
            mode: isPrescreen ? 'Prescreen' : 'Evaluation',
            pk_InterviewDate: dateToUse,
          },
          formatBearerToken(token),
        )
          .then((result) => {
            if (isCurrentRequest()) {
              if (result.data && result.data.Status && result.data.Status.Status && candidateSelectionRef.current.appliedStatusVersion === appliedStatusVersion) {
                setCandidateEvaluationStatus(result.data.Status);
                setDNRStatus(result.data.Status.EnableDoNotRank);
              }
              setCandidateEvaluation(result.data);
              setCurrentlGettingEval(false);
            }

            return result;
          })
          .catch((err) => {
            return err;
          });
      })
      .catch((err) => {
        if (isCurrentRequest()) {
          checkLoginForError({ err, loginWithRedirect });
        }
      });
  };

  const getCandidate = (id, forcedDate) => {
    // don't get the user if it's already the one selected
    if (selectedCandidate && selectedCandidate.pk_Candidate === id && candidateSelectionRef.current.id === id) return;

    candidateSelectionRef.current.id = id;
    candidateSelectionRef.current.version += 1;
    setCandidateEvaluationStatus('');
    setDNRStatus(null);
    const selectionVersion = candidateSelectionRef.current.version;
    getCandidateDetails(id, false, selectionVersion);
    getCandidateEvaluation(id, forcedDate, selectionVersion);
    setSelectedCandidateId(id);
  };

  const guardCandidateSetter = (setter) => {
    const contextKey = candidateContextKey;
    const selectionVersion = renderedSelectionVersion;
    return (value) => {
      if (candidateContextRef.current === contextKey && candidateSelectionRef.current.version === selectionVersion) {
        setter((previous) => {
          if (candidateContextRef.current !== contextKey || candidateSelectionRef.current.version !== selectionVersion) return previous;
          return typeof value === 'function' ? value(previous) : value;
        });
      }
    };
  };

  const handleSelectedCandidateChange = (candidate) => {
    if (candidateContextRef.current !== candidateContextKey || candidateSelectionRef.current.version !== renderedSelectionVersion) return;
    if (!candidate) {
      candidateSelectionRef.current.version += 1;
      candidateSelectionRef.current.id = null;
      setSelectedCandidateId(null);
      setCandidateEvaluation(null);
      setCandidateEvaluationStatus('');
      setDNRStatus(null);
    }
    setSelectedCandidate(candidate);
  };

  const getDataTypes = () => {
    if (!dContext || !dContext.season || !dContext.department) {
      return;
    }
    // /department/dataTypes?pk_Department=6
    getTokenSilently()
      .then((token) => {
        fetchDataAgnostic(
          'department/dataTypes',
          {
            pk_Department: dContext.department.pk_Department,
            pk_Season: dContext.season.pk_Season,
          },
          formatBearerToken(token),
        )
          .then((result) => {
            const { data } = result;
            // filter by displayed properties
            const filteredObject = Object.keys(data)
              // .filter((key) => data[key].DisplayToEvaluator)
              .filter((key) => {
                const item = data[key];
                return item.Enabled; //&& (item.Type == 1 || item.Type == 3);
              })
              .reduce((res, key) => ((res[key] = data[key]), res), {});
            setDataTypes(Object.values(filteredObject));
          })
          .catch((err) => {});
      })
      .catch((err) => {
        checkLoginForError({ err, loginWithRedirect });
      });
  };

  const checkInactivity = (forceLogout) => {
    const now = dayjs();
    const lastActivity = localStorage.getItem('lastActivity');
    const schedStart = scheduleStartTime.current;
    const schedEnd = scheduleEndTime.current;
    if (!schedStart || !schedEnd) {
      return;
    }

    const lastActivityMoment = lastActivity ? dayjs(lastActivity) : null;
    const currentInactivityLength = now.diff(lastActivityMoment, 'minutes');
    const isMeetingInProgress = now.isSameOrAfter(schedStart) && now.isSameOrBefore(schedEnd);

    if (
      !isMeetingInProgress &&
      !isEmbedded &&
      (!lastActivity ||
        (lastActivity && currentInactivityLength > inactivityWait && !hasFiredInactivityPopupRef.current))
    ) {
      hasFiredInactivityPopupRef.current = true;
      // const autoLogoutTimeout = setTimeout(() => {
      //   logout();
      // }, 40000);

      if (forceLogout) {
        sessionStorage.removeItem('roleChoice');
        logout();
      } else {
        Swal.fire({
          title: 'Inactivity Detected',
          text: 'Are you still there?',
          showDenyButton: true,
          confirmButtonText: 'Yes',
          denyButtonText: 'No, Log me out',
          denyButtonColor: 'red',
          timer: 30000,
          timerProgressBar: true,
        }).then((res) => {
          hasFiredInactivityPopupRef.current = false;
          if (res.dismiss === Swal.DismissReason.timer) {
            logout();
            sessionStorage.removeItem('roleChoice');
          } else if (res.isConfirmed) {
            // YES STILL HERE
            // clearTimeout(autoLogoutTimeout);
          } else {
            // logout
            logout();
            sessionStorage.removeItem('roleChoice');
          }
        });
      }
    } else if (isMeetingInProgress) {
      localStorage.setItem('lastActivity', now.toISOString());
    }
  };

  const renderWarningBanner = () => {
    const selectedEvaluatorEmail = `${selectedEvaluator?.Auth0Email || ''}`.trim().toLowerCase();
    const loggedInUserEmail = `${loggedInUser?.email || ''}`.trim().toLowerCase();
    const hasMatchingPkUser =
      selectedEvaluator &&
      loggedInUser &&
      selectedEvaluator.pk_User != null &&
      loggedInUser.pk_User != null &&
      selectedEvaluator.pk_User === loggedInUser.pk_User;
    const hasMatchingEmail = selectedEvaluatorEmail !== '' && selectedEvaluatorEmail === loggedInUserEmail;
    const isSelectedEvaluatorLoggedInUser = hasMatchingPkUser || hasMatchingEmail;

    if (selectedEvaluator && loggedInUser && !isSelectedEvaluatorLoggedInUser) {
      const { UserFirst = '', UserLast = '' } = selectedEvaluator;
      const userName = `${UserFirst} ${UserLast}`;

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            textAlign: 'center',
            paddingTop: 5,
            paddingBottom: 5,
            backgroundColor: '#f0ad4e',
            justifyContent: 'center',
          }}
        >
          <span>
            You are currently acting on behalf of <b>{` ${userName}`}</b>.
          </span>
        </div>
      );
    } else if (selectedEvaluator && loggedInUser && isSelectedEvaluatorLoggedInUser) {
      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 12,
            flexWrap: 'wrap',
            textAlign: 'center',
            paddingTop: 10,
            paddingBottom: 10,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: '#d9534f',
            color: 'white',
            justifyContent: 'center',
          }}
        >
          <span style={{ fontWeight: 'bold' }}>
            Notifications are not functional from this view.{' '}
            <span
              style={{
                textDecoration: 'underline',
                cursor: activeReduxDatePk ? 'pointer' : 'not-allowed',
                opacity: activeReduxDatePk ? 1 : 0.7,
              }}
              onClick={() => {
                if (!activeReduxDatePk) {
                  return;
                }
                window.location.assign(`/user/evaluate/${activeReduxDatePk}`);
              }}
            >
              Switch to evaluator portal.
            </span>
          </span>
        </div>
      );
    } else {
      return <br />;
    }
  };

  // if there are no users don't show loading icon. Just display no results
  if (candidateLoadError) {
    return (
      <div role="alert" style={{ padding: 24, textAlign: 'center' }}>
        <p>Unable to load candidates. Please try again.</p>
        <Button color="primary" onClick={() => (isPrescreen ? getPrescreen() : getCandidateForDate())}>
          Retry
        </Button>
      </div>
    );
  }

  if (isLoading || candidatesLoading) {
    return (
      <div
        style={{
          width: `100%`,
          height: '50vh',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ height: 100, justifyContent: 'center', alignItems: 'center' }}>
          <Loading
            options={{
              labelText: 'Loading. . .',
              labelStyle: { fontSize: 15, textAlign: 'center', fontWeight: 'bold' },
            }}
          />
        </div>
      </div>
    );
  }

  const handleMeetingClick = async (item) => {
    setDisableJoinMeetingButton(true);

    const {
      VirtualMeetingMode,
      isCustomMeeting,
      CustomMeetingUrl,
      isScheduleBlock,
      CustomUrl,
      isFlexEvent,
      VirtualRoomType,
      UrlType,
    } = item;

    if (isScheduleBlock) {
      try {
        const response = await requestVirtualMeetingEvaluator(item);
        if (!response) {
          return;
        }

        const { data } = response;
        const { DialInNumbers, JoinURL, MeetingId, Password } = data;
        handleZoomClick({ url: JoinURL, mobileNumbers: DialInNumbers, password: Password, meetingId: MeetingId });
      } catch (err) {
        Swal.fire('Error!', `Unable to start meeting: ${err.message || 'Network error'}`, 'error');
      } finally {
        setDisableJoinMeetingButton(false);
      }

      return;
    }

    let urlToUse = allDayRoom;
    if (isCustomMeeting) {
      if (VirtualRoomType === 'Custom' && CustomMeetingUrl) {
        urlToUse = CustomMeetingUrl;
      }
    }

    if (isFlexEvent && UrlType) {
      if (UrlType === 'AllDay') {
      } else {
        urlToUse = CustomUrl;
      }
    }

    if (urlToUse) {
      openURLInNewTab(urlWithHttpProtocol(urlToUse));
    } else {
      Swal.fire('Error!', 'No link to join. No event has been created. Please contact your coordinator.', 'error');
    }

    setDisableJoinMeetingButton(false);
  };

  if (isMobile) {
    return (
      <Col>
        <form id="zoom_form_eval" target="rezrate-video"></form>
        {renderMeetingDetailsCard({
          showMeetingCard,
          setShowMeetingCard,
          meetingLink,
          setCopied,
          copied,
          zoomInfo,
          zoomPassword,
          mainRoomDescription,
          meetingId,
          nonZoomInfo,
        })}
        <MobileComponent
          adjacentDates={adjacentDates}
          alarms={alarms}
          allDayRoom={allDayRoom}
          mainRoomUrlDetails={mainRoomUrlDetails}
          candidateEvaluation={candidateEvaluation}
          candidateEvaluationStatus={candidateEvaluationStatus}
          candidateInfo={candidateInfo}
          candidateSortTypes={candidateSortTypes}
          checkIfEvalsAreLocked={checkIfEvalsAreLocked}
          checkIfStatusNeedsChangingToModify={checkIfStatusNeedsChangingToModify}
          currentCandidateSortType={currentCandidateSortType}
          currentlyGettingEval={currentlyGettingEval}
          dataTypes={dataTypes}
          dContext={dContext}
          differences={differences}
          disableJoinMeetingButton={disableJoinMeetingButton}
          DNRStatus={DNRStatus}
          evalStatus={evalStatus}
          evaluationsLocked={evaluationsLocked}
          filterCandidateInfo={filterCandidateInfo}
          firstBlockEarlyJoin={firstBlockEarlyJoin}
          firstBlockEarlyJoinInMinutes={firstBlockEarlyJoinInMinutes}
          getCandidate={getCandidate}
          getCandidateDetails={getCandidateDetails}
          getCandidateEvaluation={getCandidateEvaluation}
          getCandidateForDate={getCandidateForDate}
          getCandidateStatus={getCandidateStatus}
          getInfo={getInfo}
          getNeedsAttention={getNeedsAttention}
          getPrescreen={getPrescreen}
          handleDateChange={handleDateChange}
          handleMeetingClick={handleMeetingClick}
          handleZoomClick={handleZoomClick}
          headerHeight={headerHeight}
          heightOfHeader={heightOfHeader}
          incompleteCandidates={incompleteCandidates}
          indexesWithDifferences={indexesWithDifferences}
          informUserMeetingIsStartingLocally={informUserMeetingIsStartingLocally}
          interviewHasPassed={interviewHasPassed}
          interviewIsToday={interviewIsToday}
          isAdmin={isAdmin}
          isEmbedded={isEmbedded}
          isPopout={isPopout}
          isLoading={isQuietLoading || isLoading}
          isMobile={true}
          isPrescreen={isPrescreen}
          lockedStatuses={lockedStatuses}
          minutesToUpdate={minutesToUpdateToDisplay / 60000}
          parentActiveTab={activeTab}
          pk_User={pk_User}
          reduxDate={reduxDate}
          requestVirtualMeetingEvaluator={requestVirtualMeetingEvaluator}
          requestZoomMeeting={requestZoomMeeting}
          schedule={schedule}
          scheduleError={error}
          Schedules4Eval__pkUUID_Schedule={Schedules4Eval__pkUUID_Schedule}
          Schedules4EvalJoinManualURL={Schedules4EvalJoinManualURL}
          selectedCandidateId={selectedCandidateId}
          selectedTimeSlot={selectedTimeSlot}
          selectedCandidate={selectedCandidate}
          selectedEvaluator={selectedEvaluator} // From AdminEvaluate, Admin's Evaluate tab.
          setAlarms={setAlarms}
          setCandidateEvaluation={guardCandidateSetter(setCandidateEvaluation)}
          setCandidateEvaluationStatus={guardCandidateSetter(setCandidateEvaluationStatus)}
          setDisableJoinMeetingButton={setDisableJoinMeetingButton}
          setDNRStatus={guardCandidateSetter(setDNRStatus)}
          setEvalStatus={guardCandidateSetter(setEvalStatus)}
          setLargePhoto={setLargePhoto}
          setParentActiveTab={setActiveTab}
          setSchedules4Eval__pkUUID_Schedule={setSchedules4Eval__pkUUID_Schedule}
          setSchedules4EvalJoinManualURL={setSchedules4EvalJoinManualURL}
          setSelectedTimeSlot={(item) => {
            pk_TimeSlotRef.current = item.pk_Timeslot;
            setSelectedTimeSlot(item);
          }}
          setSelectedCandidate={handleSelectedCandidateChange}
          setShowLargePhoto={setShowLargePhoto}
          setShowRed={setShowRed}
          setUserIdOnCurrentInterview={setUserIdOnCurrentInterview}
          showRed={showRed}
          sortCandAscending={sortCandAscending}
          sortCandidates={sortCandidates}
          timeoutDurationInMinutes={userInformation ? userInformation.DeptSettingsEvalTimeout : 1}
          VirtualMeetingMode={virtualMeetingMode}
          enableEmbeddedMeetings={enableEmbeddedMeetings}
          userIdOnCurrentInterview={userIdOnCurrentInterview}
        />
      </Col>
    );
  } else {
    return (
      <div
        style={
          isEmbedded
            ? {
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                minHeight: 0,
                overflow: 'hidden',
              }
            : { width: '100%', minWidth: 0 }
        }
      >
        <form id="zoom_form_eval" target="rezrate-video"></form>
        {renderWarningBanner()}
        {renderMeetingDetailsCard({
          showMeetingCard,
          setShowMeetingCard,
          meetingLink,
          setCopied,
          copied,
          zoomInfo,
          zoomPassword,
          mainRoomDescription,
          meetingId,
        })}
        <div style={isEmbedded ? { flex: 1, minHeight: 0, overflow: 'hidden' } : undefined}>
          <BrowserComponent
            adjacentDates={adjacentDates}
            alarms={alarms}
            allDayRoom={allDayRoom}
            mainRoomUrlDetails={mainRoomUrlDetails}
            candidateEvaluation={candidateEvaluation}
            candidateEvaluationStatus={candidateEvaluationStatus}
            candidateInfo={candidateInfo}
            candidateSortTypes={candidateSortTypes}
            checkIfEvalsAreLocked={checkIfEvalsAreLocked}
            checkIfStatusNeedsChangingToModify={checkIfStatusNeedsChangingToModify}
            currentCandidateSortType={currentCandidateSortType}
            currentlyGettingEval={currentlyGettingEval}
            dataTypes={dataTypes}
            dContext={dContext}
            differences={differences}
            disableJoinMeetingButton={disableJoinMeetingButton}
            DNRStatus={DNRStatus}
            evalStatus={evalStatus}
            evaluationsLocked={evaluationsLocked}
            filterCandidateInfo={filterCandidateInfo}
            firstBlockEarlyJoin={firstBlockEarlyJoin}
            firstBlockEarlyJoinInMinutes={firstBlockEarlyJoinInMinutes}
            getCandidate={getCandidate}
            getCandidateDetails={getCandidateDetails}
            getCandidateEvaluation={getCandidateEvaluation}
            getCandidateForDate={getCandidateForDate}
            getCandidateStatus={getCandidateStatus}
            getInfo={getInfo}
            getNeedsAttention={getNeedsAttention}
            getPrescreen={getPrescreen}
            handleDateChange={handleDateChange}
            handleMeetingClick={handleMeetingClick}
            handleZoomClick={handleZoomClick}
            headerHeight={headerHeight}
            heightOfHeader={heightOfHeader}
            incompleteCandidates={incompleteCandidates}
            indexesWithDifferences={indexesWithDifferences}
            informUserMeetingIsStartingLocally={informUserMeetingIsStartingLocally}
            interviewHasPassed={interviewHasPassed}
            interviewIsToday={interviewIsToday}
            isAdmin={isAdmin}
            isEmbedded={isEmbedded}
            isPopout={isPopout}
            isLoading={isQuietLoading || isLoading}
            lockedStatuses={lockedStatuses}
            minutesToUpdate={minutesToUpdateToDisplay / 60000}
            parentActiveTab={activeTab}
            pk_User={pk_User}
            reduxDate={reduxDate}
            requestVirtualMeetingEvaluator={requestVirtualMeetingEvaluator}
            requestZoomMeeting={requestZoomMeeting}
            schedule={schedule}
            scheduleError={error}
            Schedules4Eval__pkUUID_Schedule={Schedules4Eval__pkUUID_Schedule}
            Schedules4EvalJoinManualURL={Schedules4EvalJoinManualURL}
            selectedCandidateId={selectedCandidateId}
            selectedTimeSlot={selectedTimeSlot}
            selectedCandidate={selectedCandidate}
            selectedEvaluator={selectedEvaluator} // From AdminEvaluate, Admin's Evaluate tab.
            setAlarms={setAlarms}
            setCandidateEvaluation={guardCandidateSetter(setCandidateEvaluation)}
            setCandidateEvaluationStatus={guardCandidateSetter(setCandidateEvaluationStatus)}
            setDisableJoinMeetingButton={setDisableJoinMeetingButton}
            setDNRStatus={guardCandidateSetter(setDNRStatus)}
            setEvalStatus={guardCandidateSetter(setEvalStatus)}
            setLargePhoto={setLargePhoto}
            setParentActiveTab={setActiveTab}
            setSchedules4Eval__pkUUID_Schedule={setSchedules4Eval__pkUUID_Schedule}
            setSchedules4EvalJoinManualURL={setSchedules4EvalJoinManualURL}
            setSelectedTimeSlot={(item) => {
              pk_TimeSlotRef.current = item.pk_Timeslot;
              setSelectedTimeSlot(item);
            }}
            setSelectedCandidate={handleSelectedCandidateChange}
            setShowLargePhoto={setShowLargePhoto}
            setShowRed={setShowRed}
            setUserIdOnCurrentInterview={setUserIdOnCurrentInterview}
            showRed={showRed}
            sortCandAscending={sortCandAscending}
            sortCandidates={sortCandidates}
            timeoutDurationInMinutes={userInformation ? userInformation.DeptSettingsEvalTimeout : 1}
            VirtualMeetingMode={virtualMeetingMode}
            enableEmbeddedMeetings={enableEmbeddedMeetings}
            userIdOnCurrentInterview={userIdOnCurrentInterview}
          />
        </div>
      </div>
    );
  }
};

export default MobileFork;
